export default "/images/42afc997d2484cbc515f3c792c26d1a9.avif";